import type { Team } from '@/types';

export const teams: Team[] = [
  {
    id: 'T-01',
    name: 'A Ekibi',
    members: ['Hakan Kaya', 'Serkan Uzun', 'Mert Aydın'],
    status: 'Aktif İşte',
    currentJob: 'Villa — Beykoz',
    location: 'Beykoz, Kavacık Mah.',
    nextJobTime: '',
  },
  {
    id: 'T-02',
    name: 'B Ekibi',
    members: ['Cem Yıldırım', 'Onur Şahin'],
    status: 'Müsait',
    currentJob: 'Sonraki İş 14:00',
    location: 'Ataşehir — Residence',
    nextJobTime: '14:00',
  },
  {
    id: 'T-03',
    name: 'C Ekibi',
    members: ['Baran Demir', 'Emir Tekin'],
    status: 'Müsait',
    currentJob: '',
    location: '',
    nextJobTime: '',
  },
];